import React from 'react';
import { LineupData } from '../types';
import { Music, Pencil, Trash2 } from 'lucide-react';

interface LineupListProps {
  lineup: LineupData[];
  onEditLineup: (lineup: LineupData) => void;
  onDeleteLineup: (lineupId: string) => void;
  onToggleLineup: (lineupId: string, isActive: boolean) => void;
}

const LineupList: React.FC<LineupListProps> = ({
  lineup,
  onEditLineup,
  onDeleteLineup,
  onToggleLineup
}) => {
  if (lineup.length === 0) {
    return (
      <div style={{ padding: "32px 16px", textAlign: "center", borderRadius: 14, background: 'var(--v3-bg-subtle, rgba(255,255,255,0.02))', border: '1px dashed var(--v3-border-medium, rgba(255,255,255,0.08))' }}>
        <Music size={28} color="var(--v3-text-faint, rgba(255,255,255,0.2))" style={{ margin: "0 auto 8px auto", display: "block" }} />
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--v3-text-main, #fff)' }}>No lineup items added yet</div>
        <p style={{ fontSize: 11, color: 'var(--v3-text-muted, rgba(255,255,255,0.4))', marginTop: 4, marginBottom: 0 }}>Click "Add Lineup Item" to get started.</p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {lineup.map((item, index) => (
        <div
          key={item.id || item.lineupId || index}
          style={{
            padding: 16,
            borderRadius: 14,
            background: "var(--v3-bg-subtle, rgba(255,255,255,0.03))",
            border: "1px solid var(--v3-border-subtle, rgba(255,255,255,0.07))",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 14,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14, flex: "1 1 240px", minWidth: 0 }}>
            {item.artistImage || item.artistImageUrl ? (
              <img
                src={
                  item.artistImageUrl
                    ? item.artistImageUrl
                    : typeof item.artistImage === 'string'
                    ? item.artistImage
                    : item.artistImage instanceof File
                    ? URL.createObjectURL(item.artistImage)
                    : ''
                }
                alt={item.name}
                style={{ width: 46, height: 46, borderRadius: 12, objectFit: 'cover', flexShrink: 0, border: '1px solid rgba(255,255,255,0.1)' }}
              />
            ) : (
              <div
                style={{
                  width: 46,
                  height: 46,
                  borderRadius: 12,
                  background: "rgba(238, 63, 124, 0.12)",
                  border: "1px solid rgba(238, 63, 124, 0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#EE3F7C",
                  flexShrink: 0,
                }}
              >
                <Music size={20} />
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--v3-text-main, #fff)" }}>
                {item.name}
              </div>

              {item.tagLine && (
                <div style={{ fontSize: 12, fontWeight: 600, color: "#F79B59" }}>
                  {item.tagLine}
                </div>
              )}

              {item.description && (
                <div style={{ fontSize: 12, color: "var(--v3-text-muted, rgba(255,255,255,0.5))", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                  {item.description}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="v3-btn-secondary"
              style={{ fontSize: 12, padding: "6px 12px" }}
              onClick={() => onEditLineup(item)}
              title="Edit Lineup"
            >
              <Pencil size={13} /> Edit
            </button>
            <button
              type="button"
              className="v3-btn-secondary"
              style={{ fontSize: 12, padding: "6px 12px", color: "#FF5D73", borderColor: "rgba(255,93,115,0.2)" }}
              onClick={() => onDeleteLineup(item.lineupId || item.id || '')}
              title="Delete Lineup"
            >
              <Trash2 size={13} /> Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LineupList;
